import { useCallback, useEffect, useRef } from 'react';

import {
  LogDevMessageKinds,
  makeLogDevMessage,
} from '@/shared/helpers/make-log-dev-message';
import { useIsOnline } from '@/shared/hooks/use-is-online';
import { useWs } from '@/shared/hooks/use-ws';
import { MessageAction, MessageType } from '@/shared/hooks/use-ws/types';

const HEARTBEAT_INTERVAL_MS = 5_000;

const logOnline = makeLogDevMessage<boolean>(
  LogDevMessageKinds.online,
  () => 'APP IS ACTIVE'
);
const logOffline = makeLogDevMessage<boolean>(
  LogDevMessageKinds.offline,
  () => 'APP IS INACTIVE'
);

export const useScreenTimeTracking = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const ws = useWs();
  const isAppOnline = useIsOnline();

  const stopInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const sendHeartbeat = useCallback(() => {
    if (import.meta.env.DEV) return;
    ws.sendMessage(MessageType.SCREENTIME, MessageAction.EXECUTE);
  }, [ws]);

  useEffect(() => {
    if (isAppOnline) {
      logOnline(true);
      stopInterval();

      intervalRef.current = setInterval(() => {
        sendHeartbeat();
      }, HEARTBEAT_INTERVAL_MS);
    } else {
      logOffline(false);
      stopInterval();
    }

    return stopInterval;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAppOnline]);
};
